export const FLEX_SHIP_MAXIMUM_AMOUNT = 151;
export const FLEX_SHIP_MINIMUM_AMOUNT = 15;
